import { StickyNote } from "lucide-react";
import { formatTimeOnly } from "./chatUtils";

const NoteBubble = ({ note }) => (
  <div className="flex justify-center my-3">
    <div className="max-w-[80%] bg-yellow-50 border border-yellow-200 rounded-lg px-3 py-2 w-full">
      <div className="flex items-center gap-1.5 mb-1">
        <StickyNote className="w-3 h-3 text-yellow-500 flex-shrink-0" />
        <span className="text-xs font-semibold text-yellow-700">Internal Note</span>
        <span className="text-xs text-gray-400 ml-auto">{note.author?.businessName || "Agent"}</span>
      </div>
      <p className="text-xs text-gray-700 whitespace-pre-wrap break-words leading-relaxed">{note.content}</p>
      <p className="text-xs text-gray-400 text-right mt-1">{formatTimeOnly(note.createdAt)}</p>
    </div>
  </div>
);

export default NoteBubble;
